<template>
  <v-content>
    <OLoadingDialog :value="isLoading" />

    <EditAccountDetailsDialog ref="editDialog" />
    <EditSubDetailsDialog ref="editSubDialog" />

    <div
      v-if="row != null"
      class="d-flex fill-width fill-height align-stretch pa-2 maxh-1bar"
    >
      <div
        class="flex-grow-0 flex-shrink-0 pa-2 max-height"
        style="width: 400px;"
      >
        <v-card class="fill-height scroll-y">
          <v-toolbar flat>
            <v-btn icon @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Account #{{ row.id }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="openEditDialog">
              <v-icon>edit</v-icon>
            </v-btn>
            <OMenuButton :menuOpts="menuOpts" :btnSize="48" btnClass="ml-2" />
          </v-toolbar>
          <v-card-text class="pa-3 v-row children-ma-3">
            <div class="cap-cont" v-for="(item, i) in items" :key="i">
              <label>{{ item.label }}</label>
              <p>{{ item.value }}</p>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="flex-grow-1 pa-2 max-height">
        <v-card>
          <v-toolbar class="card-bar">
            <v-toolbar-title>Regras de Notificação</v-toolbar-title>
            <v-spacer />
            <v-btn color="primary" @click="editSub(null)">
              Nova Regra...
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-0">
            <ODataTable
              :items="subs"
              :spec="spec"
              @rowClicked="editSub"
            />
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-content>
</template>

<script>
import { Account, Subscription } from '@/models'
import { brDateTime } from 'oderon-commons/src/formatters'
import strCriteria from '@/views/beeper/subscriptions/str-criteria'
import { isBlank } from 'oderon-commons/src/utils'

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    OMenuButton: require('oderon-vue/cpts/OMenuButton').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    EditAccountDetailsDialog: require('./EditAccountDetailsDialog').default,
    EditSubDetailsDialog: require('@/views/beeper/subscriptions/EditSubDetailsDialog').default
  },
  props: {
    accountId: { required: true }
  },
  data() {
    return {
      isLoading: true,
      row: null,
      subs: [],

      spec: {
        defaultSortable: false,
        columns: [
          { t: 'Nome', d: 'name' },
          { t: 'Critério', d: 'criteria', f: strCriteria },
          { t: 'Criada em|', d: 'createdAt', f: brDateTime },
          { t: 'Atualizada em|', d: 'updatedAt', f: brDateTime }
        ]
      },

      menuOpts: [
        {
          text: 'Alterar senha...',
          icon: 'lock',
          onClick: () => this.changePassword()
        },
        {
          text: 'Desligar...',
          icon: 'block',
          onClick: () => this.confirmDelete()
        }
      ]
    }
  },
  computed: {
    items() {
      return [
        { label: 'Email', value: this.row.email },
        { label: 'Nome completo', value: this.row.fullName || '-' },
        { label: 'Apps permitidas', value: (this.row.allowedApps || []).join(', ') || '-' },
        { label: 'Observações', value: this.row.comments || '-' },
        { label: 'Criado', value: brDateTime(this.row.createdAt) },
        { label: 'Atualizado', value: brDateTime(this.row.updatedAt) }
      ]
    }
  },
  mounted() {
    this.reload()
  },
  watch: {
    accountId() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let row = await Account.findById(this.accountId)
      let subs = await Subscription.findByAccount(row.id)
      this.row = row
      this.subs = subs
    },

    async openEditDialog() {
      let dialog = this.$refs.editDialog,
        res = await dialog.open(this.accountId)

      if (res === 'DELETE') {
        await this.confirmDelete()
      } else if (res != null) {
        await this.$loading(async () => {
          await Account.save(res)
          await this.fetchData()
        })

        this.$snack('Salvo com sucesso')
      }
    },

    async changePassword() {
      let newPassword = await this.$prompt({
        label: 'Digite uma nova senha para esta conta'
      })

      if ( !isBlank(newPassword) ) {
        await this.$loading(async () => {
          await Account.updatePassword(this.accountId, newPassword)
          await this.fetchData()
          this.$snack('Salvo com sucesso')
        })
      }
    },

    async editSub(sub) {
      let dialog = this.$refs.editSubDialog,
        res = await dialog.open(sub ? sub.id : null)

      if (res === 'DELETE') {
        await this.confirmDeleteSub(sub)
      } else if (res != null) {
        res.accountId = this.row.id

        await this.$loading(async () => {
          await Subscription.save(res)
          await this.fetchData()
        })

        this.$snack('Salvo com sucesso')
      }
    },

    async confirmDeleteSub(sub) {
      let result = await this.$confirm({
        message: `Deseja remover a regra ${sub.name}?`,
        okText: 'Sim, remover',
        cancelText: 'Não, cancelar'
      })

      if (result) {
        await this.$loading(async () => {
          await Subscription.delete(sub.id)
          await this.fetchData()
        })

        this.$snack('Removida com sucesso')
      }
    },

    async confirmDelete() {
      let result = await this.$confirm({
        message: `Deseja desativar o usuário ${this.row.email}?`,
        okText: 'Sim, desativar',
        cancelText: 'Não, cancelar'
      })

      if (result) {
        await this.$loading(async () => {
          await Account.delete(this.accountId)
          await this.$router.push('/tools/gateman/accounts')
        })

        this.$snack('Desativado com sucesso')
      }
    }
  }
}
</script>

<style></style>
